<template>
  <div>
    <v-dialog persistent v-model="dialog" width="1280px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.chooseInfo", [$t("Material.templates.title")]) }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="close()">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-row dense class="mx-5">
          <v-col cols="12" sm="5">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="templateKeyword"
                @text="KeyWord = $event"
                :label="$t('Material.templates.name')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" align-self="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="5" align-self="center">
            <v-row dense align="center" class="pa-1">
              <div
                class="caption grey--text input-chip-group-label"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ $t("Material.templates.usable") }}
              </div>
              <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
                <v-chip
                  small
                  label
                  filter
                  class="mx-1"
                  color="primary"
                  text-color="white"
                  :key="1"
                  :value="1"
                >
                  {{ $t("Material.templates.usable_on") }}
                </v-chip>
                <v-chip
                  small
                  label
                  filter
                  class="mx-1"
                  color="grey"
                  text-color="white"
                  :key="0"
                  :value="0"
                >
                  {{ $t("Material.templates.usable_off") }}
                </v-chip>
              </v-chip-group>
            </v-row>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="templateItems"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          :height="height"
          fixed-header
          :footer-props="footerProps"
          v-resize="resizeHeader"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td></td>
              <td align="center" class="pt-3 pb-2">
                <v-select
                  dense
                  hide-details
                  :label="$t('MaterialTemplate.priceTypeAll')"
                  placeholder="-"
                  style="
                    max-width: 140px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  :items="priceTypesSelect"
                  item-text="text"
                  item-value="value"
                  v-model="priceTypeAll"
                  :disabled="!savable"
                />
              </td>
              <td align="end">
                <v-text-field
                  v-if="!priceTypeAll"
                  single-line
                  dense
                  hide-details
                  v-model="priceAll"
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    priceAll =
                      priceAll > 0
                        ? $numberFormatter.formatWithDotNoMoreThan(priceAll, 2)
                        : priceAll
                  "
                  style="max-width: 100px; margin-left: auto"
                  :disabled="!savable"
                />
              </td>
              <td align="end">
                <v-text-field
                  v-if="
                    priceTypeAll == 4 || priceTypeAll == 2 || priceTypeAll == 3
                  "
                  single-line
                  dense
                  hide-details
                  v-model="floatUpPercentAll"
                  type="number"
                  min="0"
                  suffix="%"
                  @blur="
                    floatUpPercentAll =
                      $numberFormatter.formatWithDotNoMoreThan(
                        floatUpPercentAll,
                        2
                      )
                  "
                  style="max-width: 100px; margin-left: auto"
                  :disabled="!savable"
                />
              </td>
              <td>
                <v-select
                  dense
                  hide-details
                  placeholder="-"
                  style="
                    max-width: 140px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  :items="unitSettingSelect"
                  item-text="text"
                  item-value="value"
                  clearable
                  v-model="unitSettingAll"
                  :disabled="!savable"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="multipleAll"
                  class="input-center"
                  type="number"
                  min="0"
                  @blur="
                    multipleAll = $numberFormatter.formatWithDotNoMoreThan(
                      multipleAll,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="!savable"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="minNumAll"
                  class="input-center"
                  type="number"
                  min="0"
                  @blur="
                    minNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      minNumAll,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="!savable"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="maxNumAll"
                  class="input-center"
                  type="number"
                  min="0"
                  @blur="
                    maxNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      maxNumAll,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="!savable"
                />
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    templates.find((detail) => detail.hide_flg != hideAll)
                      ? true
                      : false
                  "
                  v-model="hideAll"
                  :true-value="0"
                  :false-value="1"
                  :disabled="!savable"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.hideAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                v-if="settings && !settings.sub_account_enable"
                class="align-center"
              >
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    templates.find((detail) => detail.is_follow != followAll)
                      ? true
                      : false
                  "
                  v-model="followAll"
                  :true-value="false"
                  :false-value="true"
                  :disabled="!savable"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.followAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    templates.find((detail) => detail.status != statusAll)
                      ? true
                      : false
                  "
                  v-model="statusAll"
                  :true-value="1"
                  :false-value="0"
                  :disabled="!savable"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.valid_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                v-if="
                  settings &&
                  settings.sub_account_enable &&
                  settings.sub_account_enable != 2
                "
              ></td>
            </tr>
          </template>
          <template v-slot:item.price_type="{ item }">
            <v-select
              v-if="item.is_follow"
              disabled
              single-line
              dense
              hide-details
              style="max-width: 160px; margin-left: auto; margin-right: auto"
              :items="priceTypesSelect"
              item-text="text"
              item-value="value"
              :value="0"
            />
            <v-select
              v-else
              single-line
              dense
              hide-details
              style="max-width: 160px; margin-left: auto; margin-right: auto"
              :items="priceTypesSelect"
              item-text="text"
              item-value="value"
              v-model="item.price_type"
              :disabled="!savable"
            />
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              v-if="item.is_follow"
              disabled
              single-line
              dense
              hide-details
              :value="material.supply_price"
              :prefix="$t('Global.money')"
              style="max-width: 100px; margin-left: auto"
              @wheel.prevent
            />
            <v-text-field
              v-else-if="!item.price_type"
              single-line
              dense
              hide-details
              v-model="item.supply_price"
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.supply_price = $numberFormatter.formatWithDotNoMoreThan(
                  item.supply_price,
                  2
                )
              "
              style="max-width: 100px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
            <span v-else-if="item.price_type == 3">
              {{ $t("Global.money") }} {{ item.last_in_price_calculate | formatMoney }}
            </span>
            <span v-else-if="item.price_type == 4">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text-no-wrap my-0"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $t("Global.money") }}
                    {{ item.float_up_price | formatMoney }}
                  </span>
                </template>
                <span>{{ $t("MaterialTemplate.floatUpPriceTooltip") }}</span>
              </v-tooltip>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.cost_price_percent="{ item }">
            <v-text-field
              v-if="item.price_type == 2"
              single-line
              dense
              hide-details
              v-model="item.cost_price_percent"
              type="number"
              min="0"
              suffix="%"
              @blur="
                item.cost_price_percent =
                  $numberFormatter.formatWithDotNoMoreThan(
                    item.cost_price_percent,
                    2
                  )
              "
              style="max-width: 100px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
            <v-text-field
              v-else-if="item.price_type == 3"
              single-line
              dense
              hide-details
              v-model="item.batch_price_percent"
              type="number"
              min="0"
              suffix="%"
              @blur="
                item.batch_price_percent =
                  $numberFormatter.formatWithDotNoMoreThan(
                    item.batch_price_percent,
                    2
                  )
              "
              style="max-width: 100px; margin-left: auto"
            />
            <v-text-field
              v-else-if="item.price_type == 4"
              single-line
              dense
              hide-details
              v-model="item.float_up_percent"
              type="number"
              min="0"
              suffix="%"
              @blur="
                item.float_up_percent =
                  $numberFormatter.formatWithDotNoMoreThan(
                    item.float_up_percent,
                    2
                  )
              "
              style="max-width: 100px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
            <span v-else>-</span>
          </template>
          <template v-slot:item.material_supply_standard.unit="{ item }">
            <v-select
              v-if="item.is_follow && !isNew"
              disabled
              single-line
              dense
              hide-details
              style="max-width: 60px; margin-right: auto; margin-left: auto"
              :items="templatesMaterial.standard.standard_details"
              item-text="unit"
              item-value="id"
              :value="material.supply_standard_detail.id"
            />
            <v-select
              v-if="item.is_follow && isNew"
              disabled
              single-line
              dense
              hide-details
              style="max-width: 60px; margin-right: auto; margin-left: auto"
              :items="material.standard.standard_details"
              item-text="unit"
              item-value="unit"
              v-model="item.unit"
            />
            <v-select
              v-else-if="!item.is_follow && isNew"
              single-line
              dense
              hide-details
              style="max-width: 60px; margin-right: auto; margin-left: auto"
              :items="material.standard.standard_details"
              item-text="unit"
              item-value="unit"
              v-model="item.unit"
              :disabled="!savable"
            />
            <v-select
              v-else-if="!item.is_follow && !isNew"
              single-line
              dense
              hide-details
              style="max-width: 60px; margin-right: auto; margin-left: auto"
              :items="templatesMaterial.standard.standard_details"
              item-text="unit"
              item-value="id"
              v-model="item.standard_detail_id"
              :disabled="!savable"
            />
            <div v-if="item.rate > 1" class="mt-n5">
              <br />
              <span class="caption secondary--text">
                (1{{ item.unit }}={{ item.rate
                }}{{ material.standard.default_standard_detail.unit }})
              </span>
            </div>
          </template>
          <template v-slot:item.multiple="{ item }">
            <v-text-field
              v-if="item.is_follow"
              disabled
              single-line
              dense
              hide-details
              :value="material.multiple"
              class="input-center"
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
            />
            <v-text-field
              v-else
              single-line
              dense
              hide-details
              v-model="item.multiple"
              type="number"
              min="0"
              class="input-center"
              @blur="
                item.multiple = $numberFormatter.formatWithDotNoMoreThan(
                  item.multiple,
                  2
                )
              "
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
          </template>
          <template v-slot:item.min_num="{ item }">
            <v-text-field
              v-if="item.is_follow"
              disabled
              single-line
              dense
              hide-details
              :value="material.min"
              class="input-center"
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
            />
            <v-text-field
              v-else
              single-line
              dense
              hide-details
              v-model="item.min_num"
              type="number"
              min="0"
              class="input-center"
              @blur="
                item.min_num = $numberFormatter.formatWithDotNoMoreThan(
                  item.min_num,
                  2
                )
              "
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
          </template>
          <template v-slot:item.max_num="{ item }">
            <v-text-field
              v-if="item.is_follow"
              disabled
              single-line
              dense
              hide-details
              :value="material.max"
              class="input-center"
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
            />
            <v-text-field
              v-else
              single-line
              dense
              hide-details
              v-model="item.max_num"
              type="number"
              min="0"
              class="input-center"
              @blur="
                item.max_num = $numberFormatter.formatWithDotNoMoreThan(
                  item.max_num,
                  2
                )
              "
              style="max-width: 60px; margin-left: auto"
              @wheel.prevent
              :disabled="!savable"
            />
          </template>
          <template v-slot:item.status="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.status"
                :true-value="1"
                :false-value="0"
                :disabled="!savable"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.status
                          ? "Material.templates.usable_on"
                          : "Material.templates.usable_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.hide_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.hide_flg"
                :true-value="0"
                :false-value="1"
                :disabled="!savable"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.hide_flg
                          ? "Material.templates.hide_on"
                          : "Material.templates.hide_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.is_follow="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.is_follow"
                :true-value="false"
                :false-value="true"
                :disabled="!savable"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.is_follow
                          ? "Material.templates.custom_off"
                          : "Material.templates.custom_on"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>

          <template v-slot:item.split_price="{ item }">
            <v-btn
              v-if="item.price_type == 0"
              small
              text
              color="info"
              @click="splitPriceItem = item"
            >
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
        </v-data-table>
        <v-card-actions>
          <span class="caption">
            {{
              $t("CRUD.chooseCount", [
                templates.filter((t) => t.status && t.disabled).length,
                templates.filter((t) => t.status && !t.disabled).length,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined class="elevation-1" @click="close()">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" v-if="savable" @click="dialog = false">
            {{ $t("CRUD.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SplitPrice
      v-model="splitPriceItem"
      :mode="mode"
      :price="splitPriceItem ? Number(splitPriceItem.supply_price) : 0"
      percent
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SplitPrice from "./SplitPrice";
// import MaterialTemplates from "@/api/material_templates";

export default {
  name: "TemplatesSelectsDialog",

  props: {
    value: Boolean,
    material: Object,
    templates: Array,
    isNew: Boolean,
    templatesMaterial: Object,
    savable: Boolean,
  },

  components: {
    SearcherKeyword,
    SplitPrice,
  },

  computed: {
    headers() {
      var headers = [
        {
          text: i18n.t("Material.templates.name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "template.template_name",
          width: 200,
        },
        {
          text: i18n.t("Material.templates.price_type"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "price_type",
        },
        {
          text: i18n.t("Material.templates.price"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "price",
        },
        {
          text: i18n.t("Material.templates.supply_percentage"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "cost_price_percent",
        },
        {
          text: i18n.t("Material.templates.unit"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_supply_standard.unit",
        },
        {
          text: i18n.t("Material.templates.order_multiple"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "multiple",
        },
        {
          text: i18n.t("Material.templates.min_order_number"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "min_num",
        },
        {
          text: i18n.t("Material.templates.max_order_number"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "max_num",
        },
        {
          text: i18n.t("Material.templates.hide_flg"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "hide_flg",
        },
        {
          text: i18n.t("Material.templates.template_custom"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "is_follow",
        },
        {
          text: i18n.t("Material.templates.usable"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "status",
        },
      ];
      if (
        this.settings &&
        this.settings.sub_account_enable &&
        this.settings.sub_account_enable != 2
      ) {
        headers.push({
          text: i18n.t("Material.templates.splitPrice"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "split_price",
        });
      }

      return headers;
    },

    priceTypesSelect: () => [
      { value: 0, text: i18n.t("Material.priceTypes.custom") },
      { value: 1, text: i18n.t("Material.priceTypes.lastPrice") },
      { value: 2, text: i18n.t("Material.priceTypes.costPercent") },
      { value: 3, text: i18n.t("Material.priceTypes.lastInPrice") },
      { value: 4, text: i18n.t("Material.priceTypes.supplyPrice") },
    ],

    templateItems() {
      return this.templates.filter(
        (t) =>
          ((this.templateKeyword &&
            t.template.template_name.indexOf(this.templateKeyword) > -1) ||
            !this.templateKeyword) &&
          ((this.chooseFlgs.length &&
            (t.status
              ? this.chooseFlgs.find((flg) => flg == t.status) != undefined ||
                !t.disabled
              : this.chooseFlgs.find((flg) => flg == t.status) != undefined)) ||
            !this.chooseFlgs.length)
      );
    },
    checkPriceType() {
      if (this.templates.find((detail) => detail.price_type != 0)) {
        return true;
      }
      return false;
    },
    unitSettingSelect: () => [
      {
        value: 1,
        text: i18n.t("MaterialTemplate.unitSettings.defaultUnitAll"),
      },
      { value: 2, text: i18n.t("MaterialTemplate.unitSettings.maxUnitAll") },
    ],
    footerProps() {
      let props = Object.assign({}, i18n.t("$config.footer-props"), {})
      props.itemsPerPageOptions.unshift(-1);
      return props;
    },
    // footerProps() {
    //   return Object.assign({}, i18n.t("$config.footer-props"), {
    //     itemsPerPageOptions: [this.itemsPerPageOptions],
    //   });
    // },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    // templates: [],
    // itemsPerPageOptions: 10,
    templateKeyword: "",
    chooseFlgs: [0, 1],
    splitPriceItem: null,
    mode: "",
    priceTypeAll: -1,
    priceTypeCount: [],
    floatUpPercentAll: "",
    unitSettingAll: 0,
    multipleAll: "",
    minNumAll: "",
    maxNumAll: "",
    hideAll: 0,
    followAll: false,
    statusAll: 0,
    height: 325,
    priceAll: "",
  }),

  methods: {
    // resizeHeader() {
    //   this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    // },
    resizeHeader() {
      this.height = window.innerHeight > 800 ? 580 : 325;
    },
    onSearch() {
      this.templateKeyword = this.KeyWord;
    },
    close() {
      this.dialog = false;
      this.$emit("close", "");
    },
    save() {
      this.dialog = false;
      this.$emit("templateDetails", this.templates);
    },
    // getTemplates() {
    //   MaterialTemplates.fetchByMaterial(this.material.id, { readonly: 1 }).then(
    //     function (response) {
    //       if (response.data.status.isOK()) {
    //         this.templates = response.data.material_template_details.map(
    //           (t) => {
    //             if (t.status) {
    //               t.disabled = true;
    //             }
    //             return t;
    //           }
    //         );
    //       }
    //     }.bind(this)
    //   );
    // },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.templates.forEach((template) => {
            if (template.status != 1) {
              template.supply_price = this.material.supply_price;
            }
          });
        } else {
          this.priceTypeAll = -1;
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.templateKeyword = "";
          this.chooseFlgs = [0, 1];
          this.splitPriceItem = null;
          this.mode = "";
          this.priceTypeAll = -1;
          this.priceTypeCount = [];
          this.floatUpPercentAll = "";
          this.unitSettingAll = 0;
          this.multipleAll = "";
          this.minNumAll = "";
          this.maxNumAll = "";
          this.hideAll = 0;
          this.followAll = false;
          this.statusAll = 0;
          this.priceAll = "";
        }
      },
    },
    templates: {
      deep: true,
      handler() {
        if (
          this.templates.find(
            (detail) => detail.price_type != this.priceTypeAll
          )
        ) {
          this.priceTypeAll = -1;
        }

        this.templates.forEach((template) => {
          //汇总价格类型设置为默认供应商采购价的商品
          if (
            template.price_type == 4 &&
            this.priceTypeCount.indexOf(template.material_id) == -1
          ) {
            this.priceTypeCount.push(template.material_id);
            if (this.floatUpPercentAll)
              template.float_up_percent = this.floatUpPercentAll;
          }
          //计算新添加的商品的基准单位要货价
          if (
            !template.default_order_price &&
            template.material_supply_standard &&
            template.material_supply_standard.rate
          ) {
            template.default_order_price =
              Number(template.material_supply_price) /
              Number(template.material_supply_standard.rate);
          }
          // if (this.isNew) {
          //   if (!template.supply_price && template.supply_price !== 0) {
          //     template.supply_price = this.material.supply_price;
          //   }
          //   template.hide_flg = this.material.hide_flg;
          //   template.multiple = this.material.multiple;
          // }
          if (template.is_follow) {
            if (this.isNew) {
              template.unit = this.material.standard.standard_details.find(
                (s) => s.default_flg == 1
              )
                ? this.material.standard.standard_details.find(
                    (s) => s.default_flg == 1
                  ).unit
                : "";
            } else {
              template.standard_detail_id =
                this.templatesMaterial.standard.standard_details.find(
                  (s) => s.default_flg == 1
                )
                  ? this.templatesMaterial.standard.standard_details.find(
                      (s) => s.default_flg == 1
                    ).id
                  : "";
            }
          }

          var standard_detail = this.isNew
            ? this.material.standard.standard_details.find(
                (s) => s.unit == template.unit
              )
            : this.templatesMaterial.standard.standard_details.find(
                (s) => s.id == template.standard_detail_id
              );
          if (standard_detail) {
            template.rate = standard_detail.rate;
            //默认供应商采购价上浮百分比后的价格动态改变
            if (template.price_type == 4) {
              //要货价格与要货单位联动
              template.float_up_price =
                template.price_type == 4
                  ? this.$numberFormatter.formatTwoDot(
                      Number(template.default_order_price) *
                        Number(standard_detail.rate) *
                        (1 + template.float_up_percent / 100)
                    )
                  : 1;
            } else if (template.price_type == 3) {
              //要货价格与要货单位联动
              template.last_in_price_calculate =
                template.price_type == 3
                  ? this.$numberFormatter.formatTwoDot(
                      Number(template.last_in_price) *
                        Number(standard_detail.rate) *
                        (1 + template.batch_price_percent / 100)
                    )
                  : 1;
            }
          }
        });
      },
    },
    priceTypeAll: {
      handler() {
        if (!this.dialog) return;
        if (this.priceTypeAll != -1 && this.dialog) {
          this.templates.forEach((template) => {
            template.price_type = this.priceTypeAll;
          });
        }
      },
    },
    priceAll: {
      handler() {
        if (!this.dialog) return;
        if (!this.priceTypeAll && this.dialog) {
          this.templates.forEach((template) => {
            template.supply_price = this.priceAll;
          });
        }
      },
    },
    floatUpPercentAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          if (template.price_type == 4) {
            template.float_up_percent = this.floatUpPercentAll;
          } else if (template.price_type == 2) {
            template.cost_price_percent = this.floatUpPercentAll;
          } else if (template.price_type == 3) {
            template.batch_price_percent = this.floatUpPercentAll;
          }
        });
      },
    },
    unitSettingAll: {
      handler() {
        if (!this.dialog) return;
        let standard_detail = null;
        if (this.unitSettingAll == 1) {
          // 基准单位
          if (this.isNew) {
            standard_detail = this.material.standard.standard_details.find(
              (s) => s.default_flg == 1
            )
              ? this.material.standard.standard_details.find(
                  (s) => s.default_flg == 1
                )
              : {};
          } else {
            standard_detail =
              this.templatesMaterial.standard.standard_details.find(
                (s) => s.default_flg == 1
              )
                ? this.templatesMaterial.standard.standard_details.find(
                    (s) => s.default_flg == 1
                  )
                : {};
          }
        } else if (this.unitSettingAll == 2) {
          // 大单位
          if (this.isNew) {
            standard_detail = this.material.standard.standard_details.sort(
              (a, b) => b.rate - a.rate
            )[0];
          } else {
            standard_detail =
              this.templatesMaterial.standard.standard_details.sort(
                (a, b) => b.rate - a.rate
              )[0];
          }
        }
        if (standard_detail != null) {
          this.templates.forEach((template) => {
            if (this.isNew) {
              template.unit = standard_detail.unit;
              template.rate = standard_detail.rate;
            } else {
              template.standard_detail_id = standard_detail.id;
              template.rate = standard_detail.rate;
            }
          });
        }
      },
    },
    multipleAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.multiple = this.multipleAll;
        });
      },
    },
    minNumAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.min_num = this.minNumAll;
        });
      },
    },
    maxNumAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.max_num = this.maxNumAll;
        });
      },
    },
    hideAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.hide_flg = this.hideAll ? 1 : 0;
        });
      },
    },
    followAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.is_follow = this.followAll ? true : false;
        });
      },
    },
    statusAll: {
      handler() {
        if (!this.dialog) return;
        this.templates.forEach((template) => {
          template.status = this.statusAll ? 1 : 0;
        });
      },
    },
  },
};
</script>